import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import React, { useEffect, useState } from "react";
import { RentalRangeProperty, RentalRangePropertyRequest } from "@eres/ejari-api/Entity";
import { getEjariPropertyTypeFromTabu } from "@eres/ejari-api/Utils";
import { DateUtil, StringUtil } from "@eres/core";
import { EjariApi } from "@eres/ejari-api";
import { DisplayCurrency } from "@10x/rentalvaluation/web/screens/RVPropertyTable";
import Strings from "@my-dld/assets/strings";
import { DetailsKV } from "@my-dld/screens/MyDLD/PropertyDetails";

export function RentalRange( props: { data: AssetCard } ) {
	const { data } = props;
	const [ rentalRange, setRange ] = useState<string | undefined>( undefined );
	useEffect( () => {
		const request: RentalRangePropertyRequest = {
			propertyId: "" + data.tabuPropertyId,
			isFreeHold: data.isFreeHold,
			propertyTypeId: "" + getEjariPropertyTypeFromTabu( data.propertyTypeId ),
			contractEndDate: DateUtil.formatDate( new Date(), "MM/DD/YYYY", "en" ),
		};
		EjariApi.loadRentalRangeByProperty( request ).then( ( response: RentalRangeProperty ) => {
			if ( !StringUtil.isEmptyStringOrNull( response.MinValue ) && !StringUtil.isEmptyStringOrNull( response.MaxValue ) ) {
				const min = DisplayCurrency( response.MinValue );
				const max = DisplayCurrency( response.MaxValue );
				let rangeText = min + " - " + max;
				setRange( rangeText );
			}
		} ).catch( e => {
			console.log( e );
		} );
	}, [] );

	if ( rentalRange )
		return <DetailsKV
			label={ Strings.rental_range } value={ rentalRange }
			valueClassName={ "font-weight-bold" }/>;
	return null;
}
